import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const DEFAULT_SIZE = 24;

export default ({ color = defaultIconColor, size = DEFAULT_SIZE, ...props }: SVGComponentPropsType) => (
  <svg width={size} height={size} viewBox={`0 0 26 26`} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(0 1)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M25 10A15 15 0 0 0 1 10" />
      <path d="M20 14a8 8 0 0 0 -14 0" />
      <circle cx="13" cy="18" r="2" />
    </g>
  </svg>
);
